import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../dashboard/components/atom/Button";
import axios from "axios";
import { API_BASE_URL } from "../../../config/api";
import { Notification } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

export const CandidateView = ({ applicationId, fullName = "Candidate", jobId }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [notification, setNotification] = useState(null);

  const token = useMemo(() => localStorage.getItem("token"), []);
  const axiosCfg = useMemo(
    () => (token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    [token]
  );

  const updateStatus = async (action) => {
    if (!applicationId || !token) {
      setNotification({ type: "error", message: "Candidate or application not selected" });
      return;
    }

    let endpoint = "";
    if (action === "shortlist") {
      endpoint = `${API_BASE_URL}/api/candidates/applications/${applicationId}/shortlist`;
    } else if (action === "reject") {
      endpoint = `${API_BASE_URL}/api/candidates/applications/${applicationId}/reject`;
    } else {
      setNotification({ type: "error", message: "Unknown action" });
      return;
    }

    try {
      await axios.put(endpoint, {}, axiosCfg);
      const newStatus = action === "shortlist" ? "shortlisted" : "rejected";
      setStatus(newStatus);

      if (newStatus === "shortlisted") {
        setNotification({ type: "success", message: `${fullName} has been shortlisted!` });
        setTimeout(() => {
          if (jobId) navigate(`/shortlist/${jobId}`);
        }, 800);
      } else {
        setNotification({ type: "error", message: `${fullName} has been rejected.` });
      }
    } catch (err) {
      console.error(`Failed to ${action} candidate:`, err?.response?.data || err?.message);
      setNotification({ type: "error", message: `An error occurred while trying to ${action} the candidate.` });
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4 bg-gray-100 rounded border border-gray-200">
      {notification && (
        <Notification
          icon={notification.type === "success" ? <IconCheck size={20} /> : <IconX size={20} />}
          color={notification.type === "success" ? "teal" : "red"}
          title={notification.type === "success" ? "Success!" : "Something went wrong"}
          onClose={() => setNotification(null)}
        >
          {notification.message}
        </Notification>
      )}

      <div className="flex items-center justify-between">
        <h1 className="text-xl font-MTNfont">{fullName}</h1>
        <div className="flex gap-2">
          {status === "shortlisted" ? (
            <Button label="Shortlisted" disabled />
          ) : (
            <Button label="Shortlist" onClick={() => updateStatus("shortlist")} />
          )}
          {status === "rejected" ? (
            <Button label="Rejected" disabled />
          ) : (
            <Button label="Reject" onClick={() => updateStatus("reject")} />
          )}
        </div>
      </div>

      <style>{`
        :where(button, a, input, select, textarea):focus {
          outline: 2px solid #FFCC00;
          box-shadow: 0 0 0 3px rgba(255,204,0,.35);
          border-color: #FFCC00 !important;
        }
      `}</style>
    </div>
  );
};
